export default "__VITE_ASSET__w6qs0FEt__"